export default "__VITE_ASSET__Ba8xEXQD__"